import Button from '@material-ui/core/Button';
import {
  inject,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  images,
} from '../../assets/image';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import PageTitleWithBackButton from '../../components/PageTitleWithBackButton/PageTitleWithBackButton';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  DeglawyTrophy, IDeglawyTrophyStore,
} from '../../mobx-store/storeInterfaces/delawyTrophyInterface';
import classes from './addEditDeglawyTrophy.module.scss';

interface IProps extends WithSnackbarProps {
  deglawyTrophyStore: IDeglawyTrophyStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  selectedLang: string;
  processing: boolean;
  points: number;
  title: string;
  activeImage: string;
  inActiveImage: string;
}

@inject('deglawyTrophyStore')
class AddEditDeglawyTrophy extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  deglawyTrophyId = -1;

  lastHistory = -1;

  pageTitle = '';

  deglawyTrophyFormTitle = '';

  deglawyTrophySchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: { langCode: string; langValue: string } [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.deglawyTrophyId = props.match.params.id;
      this.pageTitle = translate('editDeglawyTrophyPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addDeglawyTrophyPageTitle', {
      });
    }
    this.initState(isConstructor);
    this.initDeglawyTrophySchema();
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.dropdownLanguages = this.getDropdownLanguages();
    this.deglawyTrophyFormTitle = translate('deglawyTrophyPageFormInfo', {
    });
  }

  componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.forceUpdate();
      if (!this.isNew) {
        this.getDeglawyTrophy(this.state.selectedLang);
      }
    }
  }

  initDeglawyTrophySchema = () => {
    this.deglawyTrophySchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      points: Yup.number()
        .moreThan(-1, 'must be positive number')
        .required('Required'),
      activeImage: Yup.array()
        .required('Required'),
      dimmedImage: Yup.array()
        .required('Required'),
    });
  };

  getFormFields = (): FormField[] => [
    {
      name: 'points',
      label: translate('deglawyTrophyPageFormPoints', {
      }),
      type: 'number',
      filedType: 'InputField',
      value: (this.isNew ? '' : `${this.props.deglawyTrophyStore.selectedDelawyTrophy.getPoints()}`),
    },
    {
      name: 'title',
      label: this.isNew ? translate('deglawyTrophyPageFormArabicTitle', {
      }) : translate('deglawyTrophyPageFormTitle', {
      }),
      type: 'text',
      filedType: 'InputField',
      value: (this.isNew ? '' : this.props.deglawyTrophyStore.selectedDelawyTrophy.getTitle()),
    },
    {
      name: 'activeImage',
      label: translate('deglawyTrophyPageFormActiveImage', {
      }),
      filedType: 'GalleryField',
      isLimitToOneImage: true,
      accept: 'image/*',
      value: (this.isNew ? [] : this.props.deglawyTrophyStore.selectedDelawyTrophy.getActiveImage()),
      size: 200,
    },
    {
      name: 'dimmedImage',
      label: translate('deglawyTrophyPageFormDimmedImage', {
      }),
      filedType: 'GalleryField',
      isLimitToOneImage: true,
      accept: 'image/*',
      value: (this.isNew ? [] : this.props.deglawyTrophyStore.selectedDelawyTrophy.getDimmedImage()),
      size: 200,
    },
  ];

  initState = (isConstructor = true) => {
    const initState: IState = {
      processing: false,
      selectedLang: languageCodes.english,
      loading: !this.isNew,
      formFields: (this.isNew ? this.getFormFields() : []),
      points: 0,
      title: 'Name',
      activeImage: '',
      inActiveImage: '',
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  getDeglawyTrophyFromValues = (values: any) => {
    const deglawyTrophy = new DeglawyTrophy();
    deglawyTrophy.setTitle(values.title);
    deglawyTrophy.setPoints(values.points);
    deglawyTrophy.setActiveImage(values.activeImage);
    deglawyTrophy.setDimmedImage(values.dimmedImage);
    return deglawyTrophy;
  };

  handelSubmit = (values: any): void => {
    this.setState({
      processing: true,
    });
    if (this.isNew) {
      const newDeglawyTrophy = this.getDeglawyTrophyFromValues(values);
      this.props.deglawyTrophyStore.createDelawyTrophy(newDeglawyTrophy)
        .then((res: any) => {
          this.props.history.push(`${res.data.deglawyTrophyId}/edit`);
          SnackBarComponent.getInstance().openSnackbar(translate('deglawyTrophyCreatedMessage', {
          }), 6000, 'success');
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('deglawyTrophyErrorMessageTrophyWithSamePoints', {
          }), 10000, 'error');
        });
    } else {
      const updatedDeglawyTrophy = this.getDeglawyTrophyFromValues(values);
      this.props.deglawyTrophyStore.updateDelawyTrophy(updatedDeglawyTrophy,
        this.deglawyTrophyId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('deglawyTrophyUpdatedMessage', {
          }), 6000, 'success');
          this.props.history.go(this.lastHistory);
        }).catch((error) => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('deglawyTrophyErrorMessageTrophyWithSamePoints', {
          }), 10000, 'error');
        });
    }
  };

  openSnackbar = (message: string, duration: number, status: 'success'|'warning'|'error'|'info') => {
    this.props.enqueueSnackbar(message, {
      autoHideDuration: duration,
      variant: status,
      action: (
        <Button color="default">Dismiss</Button>
      ),
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'right',
      },
    });
  };

  handelCancel = (): void => {
    this.props.history.goBack();
  };

  getSubmitButton = () => ({
    title: (this.isNew ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handelSubmit,
  });

  handelLanguageChange = (langCode: string) => {
    if (langCode !== this.state.selectedLang) {
      if (this.isNew) {
        this.setState({
          selectedLang: langCode,
        });
      } else {
        this.getDeglawyTrophy(langCode);
      }
    }
  };

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.handelCancel,
  });

  updateStateWithDeglawyTrophyDate = () => {
    const formFieldsWithData = this.getFormFields();
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  onChangeValues = (key: any, value: any) => {
    console.log(key, value);
    if (key === 'title') {
      this.setState({
        title: value,
      });
    }
    if (key === 'points') {
      this.setState({
        points: value,
      });
    }
    if (key === 'activeImage') {
      this.setState({
        activeImage: value.length > 0 ? value[0].preview : '',
      });
    }
    if (key === 'dimmedImage') {
      this.setState({
        inActiveImage: value.length > 0 ? value[0].preview : '',
      });
    }
  };

  render() {
    return (
      <div>
        <PageTitleWithBackButton history={this.props.history} pageTitle={this.pageTitle} />
        <div className={classes.bigContainer}>
          <div className={classes.container}>
            <div className={classes.content}>
              {
                this.state.loading
                  ? <Spinner />
                  : (
                    <GeneralFormComponent
                      dropdownLanguages={this.dropdownLanguages}
                      formTitle={this.deglawyTrophyFormTitle}
                      fields={this.state.formFields}
                      formSchema={this.deglawyTrophySchema}
                      submitButton={this.submitButton}
                      cancelButton={this.cancelButton}
                      onChangeValues={(key: any, value: any) => this.onChangeValues(key, value)}
                      processing={this.state.processing}
                    />
                  )
              }
            </div>
          </div>
          <div className={classes.previewCards}>
            <div className={classes.PreviewCard}>
              <div>
                <img className={classes.image} src={this.state.activeImage ? this.state.activeImage : images.activeTrophy} />
              </div>
              <div className={classes.cardTitle}>
                <p className={classes.cardPoints}>{`${this.state.points} Points`}</p>
                <p className={classes.cardName}>{this.state.title ? this.state.title : 'Name'}</p>
              </div>
            </div>
            <div className={classes.PreviewCard}>
              <div>
                <img className={classes.image} src={this.state.inActiveImage ? this.state.inActiveImage : images.inActiveTrophy} />
              </div>
              <div className={classes.cardTitle}>
                <p className={classes.cardPointsInactive}>{`${this.state.points} Points`}</p>
                <p className={classes.cardNameInactive}>{this.state.title ? this.state.title : 'Name'}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    if (!this.isNew) {
      this.getDeglawyTrophy(this.state.selectedLang);
    }
  }

  getDeglawyTrophy = (langCode: string) => {
    this.setState({
      loading: true,
    });
    this.props.deglawyTrophyStore.getDelawyTrophyById(this.deglawyTrophyId, langCode)
      .then(() => {
        this.updateStateWithDeglawyTrophyDate();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
  };
}

export default withRouter(AddEditDeglawyTrophy);
